import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, getData } from '../CustomUtils'
import { POINT_IN_TIME_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportGrid from '../ReportGrid.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const POINT_IN_TIME_REPORT = gql(POINT_IN_TIME_REPORT_QUERY)

export default function ClaimCountsToday({ location }) {
  console.log('ClaimCountsToday rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, POINT_IN_TIME_REPORT, 'pointInTimeReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const formatter = new Intl.NumberFormat()
    const totalColumns = [
      { columnNumber: 2, formatter: formatter.format }
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/pointInTimeReport/reports', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{ backgroundColor: 'white', width: 'auto', margin: 'auto', minWidth: '600px' }} >
          <ReportHeading title={'Point in Time Statistical Report'} widths={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            <ReportGrid results={results} doesNotHaveNumberRow={true} alignment={['left', 'right']} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} totalColSpan={1} />
          </tbody>
        </Table>
      </div>
    )
  }
}